import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { GlobalConstants } from '../common/global-constants';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private http: HttpClient, private sharedapi: SharedService) { }

  getTransactionList(pageno, limit, qstring) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl + 'get-transaction-list/' + limit + '/' + pageno + '?' + qstring, { headers: webheader })
  }

  getUser() {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl + 'get-all-active-user', { headers: webheader })
  }

  saveTransaction(data) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl + 'add-edit-transaction', data, { headers: webheader })
  }

  uploadupTransactionloadcsv(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-transaction-csv',data,{headers:webheader})
  }



}


